import React from 'react';
import { Grid } from '@mui/material';
import { Button } from './Button';
import { convertirLetraMayus } from '../../../../helpers/convertirLetraMayus';

export const DecisionResponse = (props) => {

    const { action, options } = props;

    return (
        <Grid container justifyContent='center' alignItems='center' gap={2}>
            { options?.map(o => (
                <Grid key={ o } item sm={ 4 } md={ 3 }lg={ 4 }>
                    <Button
                        title={ convertirLetraMayus(o) }
                        action={ () => action(o) }
                        breakPoints={ [12, 12, 12, 9] }
                    />
                </Grid>
            )) }
        </Grid>
    )
}